import { createSlice } from "@reduxjs/toolkit";

const activitiesSlice = createSlice({
  name: "activities",
  initialState: {
    cache: {}, // { filterKey: { 1: [...], 2: [...], ... } }
    total: {}, // { filterKey: totalCount }
  },

  reducers: {
    resetActivities(state) {
      state.cache = {};
      state.total = {};
    },

    storeActivitiesPage(state, action) {
      const { key, page, items, total } = action.payload;
      if (!state.cache[key]) state.cache[key] = {};
      state.cache[key][page] = items;
      state.total[key] = total;
    },
  },
});

export const { resetActivities, storeActivitiesPage } = activitiesSlice.actions;
export default activitiesSlice.reducer;
